<template>
  <div class="home">
    <div class="banner">
      <el-carousel
        :interval="5000"
        v-if="carouselImg.length > 2 || carouselImg.length === 1"
        arrow="always"
        height="620px"
      >
        <el-carousel-item
          v-for="(item,index) in carouselImg"
          :key="index"
          :style="'background-image: linear-gradient(to left,' + item.bgkColor[0] + ',' + item.bgkColor[1] + ')'">
          <div class="item" :style="'background-image:url(' + item.img + ')'">
            <div class="link" v-if="index === 1" :style="{top: item.top}">
              <router-link target="_blank" to="/contact">
                <div class="button" :style="item.style">
                  {{ item.title }}
                  <i class="el-icon-right"></i>
                </div>
              </router-link>
            </div>
            <div class="link" v-else>
              <router-link target="_blank" to="/contact">
                <div class="button" :style="{ marginRight: index === 2 ? item.left : 0 }">
                  {{ item.title }}
                  <i class="el-icon-right"></i>
                </div>
              </router-link>
              <div
                class="button play"
                :style="{ marginRight: item.left }"
                @click="playVideo"
                v-if="index === 0"
              >
                观看视频
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <!-- <el-carousel
        class="custom-carousel"
        :interval="5000"
        v-else
        arrow="always"
        height="620px"
      >
        <el-carousel-item :interval="5000">
          <div
            class="item"
            :style="'background-image:url(' + carouselImg[0].img + ')'"
          >
            <div class="link">
              <router-link target="_blank" to="/contact">
                <div class="button">
                  {{ carouselImg[0].title }}
                  <i class="el-icon-right"></i>
                </div>
              </router-link>
              <div
                class="button play"
                :style="{ marginRight: carouselImg[0].left }"
                @click="playVideo"
              >
                观看视频
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item :interval="5000">
          <div
            class="item"
            :style="'background-image:url(' + carouselImg[1].img + ')'"
          >
            <div class="link">
              <router-link target="_blank" to="/contact">
                <div
                  :style="'margin-right:' + carouselImg[1].left"
                  class="button"
                >
                  {{ carouselImg[1].title }}
                  <i class="el-icon-right"></i>
                </div>
              </router-link>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item :interval="5000">
          <div
            class="item"
            :style="'background-image:url(' + carouselImg[0].img + ')'"
          >
            <div class="link">
              <router-link target="_blank" to="/contact">
                <div class="button">
                  {{ carouselImg[0].title }}
                  <i class="el-icon-right"></i>
                </div>
              </router-link>
              <div
                class="button play"
                :style="{ marginRight: carouselImg[0].left }"
                @click="playVideo"
              >
                观看视频
              </div>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item :interval="5000">
          <div
            class="item"
            :style="'background-image:url(' + carouselImg[1].img + ')'"
          >
            <div class="link">
              <router-link target="_blank" to="/contact">
                <div
                  :style="'margin-right:' + carouselImg[1].left"
                  class="button"
                >
                  {{ carouselImg[1].title }}
                  <i class="el-icon-right"></i>
                </div>
              </router-link>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel> -->
    </div>

    <div class="path">
      <div class="header">
        <div class="title">内容流转全链路解决方案</div>
        <div class="context">
          <div
            class="item"
            @click="choicePathItem(1)"
            @mouseenter="animate.path.hoverItem = 1"
            @mouseleave="animate.path.hoverItem = 0"
          >
            <img
              class="img"
              :src="
                animate.path.hoverItem == 1 || animate.path.activeItem == 1
                  ? `https://respool.isheji.com/isheji/static/qiye/image/home/path_light_1.png`
                  : `https://respool.isheji.com/isheji/static/qiye/image/home/path_drak_1.png`
              "
            />
            <div class="text">资源采买</div>
          </div>
          <div class="arrow">
            <img
              src="https://respool.isheji.com/isheji/static/qiye/image/home/path_arrow.png"
            />
          </div>
          <div
            class="item"
            @click="choicePathItem(2)"
            @mouseenter="animate.path.hoverItem = 2"
            @mouseleave="animate.path.hoverItem = 0"
          >
            <img
              class="img"
              :src="
                animate.path.hoverItem == 2 || animate.path.activeItem == 2
                  ? `https://respool.isheji.com/isheji/static/qiye/image/home/path_light_2.png`
                  : `https://respool.isheji.com/isheji/static/qiye/image/home/path_drak_2.png`
              "
            />
            <div class="text">智能创意</div>
          </div>
          <div class="arrow">
            <img
              src="https://respool.isheji.com/isheji/static/qiye/image/home/path_arrow.png"
            />
          </div>
          <div
            class="item"
            @click="choicePathItem(3)"
            @mouseenter="animate.path.hoverItem = 3"
            @mouseleave="animate.path.hoverItem = 0"
          >
            <img
              class="img"
              :src="
                animate.path.hoverItem == 3 || animate.path.activeItem == 3
                  ? `https://respool.isheji.com/isheji/static/qiye/image/home/path_light_3.png`
                  : `https://respool.isheji.com/isheji/static/qiye/image/home/path_drak_3.png`
              "
            />
            <div class="text">内容管理</div>
          </div>
          <div class="arrow">
            <img
              src="https://respool.isheji.com/isheji/static/qiye/image/home/path_arrow.png"
            />
          </div>
          <div
            class="item"
            @click="choicePathItem(4)"
            @mouseenter="animate.path.hoverItem = 4"
            @mouseleave="animate.path.hoverItem = 0"
          >
            <img
              class="img"
              :src="
                animate.path.hoverItem == 4 || animate.path.activeItem == 4
                  ? `https://respool.isheji.com/isheji/static/qiye/image/home/path_light_4.png`
                  : `https://respool.isheji.com/isheji/static/qiye/image/home/path_drak_4.png`
              "
            />
            <div class="text">内容分发</div>
          </div>
          <div class="arrow">
            <img
              src="https://respool.isheji.com/isheji/static/qiye/image/home/path_arrow.png"
            />
          </div>
          <div
            class="item"
            @click="choicePathItem(5)"
            @mouseenter="animate.path.hoverItem = 5"
            @mouseleave="animate.path.hoverItem = 0"
          >
            <img
              class="img"
              :src="
                animate.path.hoverItem == 5 || animate.path.activeItem == 5
                  ? `https://respool.isheji.com/isheji/static/qiye/image/home/path_light_5.png`
                  : `https://respool.isheji.com/isheji/static/qiye/image/home/path_drak_5.png`
              "
            />
            <div class="text">数据管理</div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="mark">
          <div
            class="sub"
            :style="animate.path.markX[animate.path.activeItem - 1]"
          ></div>
        </div>

        <div class="card-item1" v-show="animate.path.activeItem == 1">
          <div class="card-show">
            <div
              :class="
                animate.path.activeItem == 1
                  ? 'animate__animated animate__fadeIn'
                  : ''
              "
            >
              <div class="title">智能创意供给</div>
              <div class="desc">
                <section>
                  平面/插画、视频/动画、直播/电商、品牌设计等8大创意服务类型以及150+创意服务形式，
                </section>
                <section>
                  亿级版权素材库，为品牌提供多元优质的内容创意供给和数字化交付
                </section>
              </div>
              <div class="content">
                  <div class="item">
                    <div class="iheader">
                      <img
                        src="https://respool.isheji.com/isheji/static/qiye/image/home/path_card_1.png"
                      />
                      <div class="iTitle">
                        <div class="bold">创意供给平台</div>
                        <div class="thin">8大创意类型150+创意形式</div>
                      </div>
                    </div>
                    <div class="iContent">
                      <section>3000+海内外独立创意人/工作室，为品牌提供多元优质的内容创意供给。</section>
                      <section>
                        平面/插画、视频/动画、直播/电商、品牌设计、UI、包装、IP、整合营销
                      </section>
                    </div>
                    <router-link to="/supply">
                      <div class="cButton">了解更多</div>
                    </router-link>
                  </div>
                  <img src="https://respool.isheji.com/isheji/static/qiye/image/home/creative_platform.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="card-item2" v-show="animate.path.activeItem == 2">
          <div class="card-show">
            <div
              :class="
                animate.path.activeItem == 2
                  ? 'animate__animated animate__fadeIn'
                  : ''
              "
            >
              <div class="title">智能内容生产</div>
              <div class="desc">
                <section>
                  10款专业级创作⼯具，实现内容从1-N的⾼效内容裂变，赋能非专业人士亦可快速完成专业级内容编辑
                </section>
              </div>
              <div class="content">
                <div
                    v-for="(item, index) in pathCard2List"
                    :key="index"
                    class="item"
                >
                    <div class="iImg">
                        <img :src="item.img" />
                    </div>
                    <div class="iContent">
                        <div class="title">
                            {{ item.title }}
                        </div>
                        <img :src="item.betaImg" alt="" v-if="index == 1" class="beta-img">
                        <div class="desc">
                            <section>
                                {{ item.text }}
                            </section>
                        </div>
                    </div>
                </div>
              </div>

              <router-link to="/output">
                <el-button class="more">了解更多</el-button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="card-item3" v-show="animate.path.activeItem == 3">
          <div class="card-show">
            <div
              :class="
                animate.path.activeItem == 3
                  ? 'animate__animated animate__fadeIn'
                  : ''
              "
            >
              <div class="title">智能内容管理</div>
              <div class="desc">
                <section>
                  为企业搭建内容中心，提供平台级的内容生产协作及数字资产的存储、管理、共享，提升企
                </section>
                <section>
                  业全域的内容分发效率，保障品牌资产的规范统一
                </section>
              </div>
              <div class="content">
                <div class="content_left">
                  <div class="left_item" v-for="(item, index) in cardItem3List" :key="index">
                    <div class="left_title">
                      <span class="icon"></span>
                      <span>{{ item.title }}</span>
                    </div>
                    <div class="left_desc">{{ item.desc }}</div>
                  </div>
                  <router-link to="/manage">
                    <div class="cButton">了解更多</div>
                  </router-link>
                </div>
                <div class="content_right">
                  <img src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/home/carditem3.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-item4" v-show="animate.path.activeItem == 4">
          <div class="card-show">
            <div
              :class="
                animate.path.activeItem == 4
                  ? 'animate__animated animate__fadeIn'
                  : ''
              "
            >
              <div class="title">智能内容分发</div>
              <div class="desc">
                <section>
                  针对公域广告媒体及私域营销场景，支持内容进行端（内容中台）
                </section>
                <section>
                  到端（用户触点）的极速分发，助力品牌实现全域增长
                </section>
              </div>
              <div class="introduce">
                <div class="context">
                  <div class="cTitle">高效的内容分发系统</div>
                  <div class="cDesc">
                    <section>
                      针对全域营销场景，对各营销链路中的环节智能把控，保证品牌规范的基础上实现千人千面的分发效率
                    </section>
                  </div>
                  <div class="cTitle">全员私域营销</div>
                  <div class="cDesc">
                    <section>
                      企业发起全员营销任务，全员根据自身内容差异化需求一键修改编辑分发，
                    </section>
                    <section>适用于大型连锁经营与私域营销企业场景</section>
                  </div>
                  <div class="cTitle">新媒体智能投放</div>
                  <div class="cDesc">
                    <section>
                      自研智能kol投放系统kolstore，支持一键分发国内主流社交平台，实现用户的精准触达
                    </section>
                  </div>
                  <router-link to="/fission">
                    <div class="cButton">了解更多</div>
                  </router-link>
                </div>
                <img
                  :src="`https://respool.isheji.com/isheji/static/qiye/image/home/path_card_10.png`"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="card-item5" v-show="animate.path.activeItem == 5">
          <div class="card-show">
            <div
              :class="
                animate.path.activeItem == 5
                  ? 'animate__animated animate__fadeIn'
                  : ''
              "
            >
              <div class="title">智能数据管理</div>
              <div class="desc">
                <section>
                  以数据驱动的高效营销体验，精准把握每一次传播的数据监测回流，
                </section>
                <section>反哺内容的优化迭代，形成营销闭环</section>
              </div>
              <div class="introduce">
                <img
                  :src="`https://respool.isheji.com/isheji/static/qiye/image/home/path_card_11.png`"
                />
                <div class="context">
                  <div class="cTitle">全面且精准的数据管理系统</div>
                  <div class="cDesc">
                    <section>
                      能力覆盖全社交平台及端内私域分发的数据监测回流，为企业提供全场景、多维度的数据分析管理能力
                    </section>
                  </div>
                  <div class="cTitle">私域营销数据回流</div>
                  <div class="cDesc">
                    <section>
                      通过对私域场景内的用户行为追踪，及时反馈私域传播的数据表现，帮助企业迅速调整内容策略
                    </section>
                  </div>
                  <div class="cTitle">新媒体大数据平台</div>
                  <div class="cDesc">
                    <section>
                      自研新媒体大数据平台kolrank，为客户提供KOL分析、粉丝画像分析、投放去水评估、品牌声量分析、
                    </section>
                    <section>数据API定制开发等多种营销数据服务</section>
                  </div>
                  <router-link to="/data">
                    <div class="cButton">了解更多</div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lab">
      <div class="content">
        <div class="title">
          <img
            src="https://respool.isheji.com/isheji/static/qiye/image/home/lab.svg"
          />
        </div>
        <div class="tips">在内容科技的宇宙探索中，我们从未停止</div>
        <div class="desc">
          <section>
            爱设计ConTech AI LAB致力于实践“科技驱动内容营销更高效”的理念，
          </section>
          <section>也是爱设计内容中台的底层核心力量支撑</section>
        </div>
        <!-- <router-link target="_blank" to='/lab'> -->
        <router-link to="/lab">
          <div class="button">
            <div class="text">立即体验</div>
            <i class="el-icon-right"></i>
          </div>
        </router-link>
      </div>
    </div>
    <div
      class="lab_banner"
      v-scroll="scrollLab"
      :style="animate.lab.bannerStyle"
    ></div>
    <div class="chart">
      <div class="title">爱设计内容中台得到行业认可</div>
      <div class="center-flex-box">
        <div class="item">
          <img
            src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/home/industry1.png"
          />
          <div class="text">行行AI AI强应用创新代表企业TOP5</div>
        </div>
        <div class="item">
          <img
            src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/home/industry2.png"
          />
          <div class="text">2023金鼠标年度最佳数字营销平台</div>
        </div>
        <div class="item">
          <img
            src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/home/industry3.png"
          />
          <div class="text">2022年度中国高科技高成长企业系列榜单</div>
        </div>
      </div>
      <div class="title">他们，都在用爱设计内容中台</div>
      <el-carousel
        :interval="7000"
        arrow="always"
        :autoplay="true"
        indicator-position="outside"
        height="530px"
      >
        <el-carousel-item
          v-for="(item, index) in textdata.chart.list"
          :key="index"
          :ref="item.name"
        >
          <div class="item">
            <div class="cImg">
              <img
                :src="`https://respool.isheji.com/isheji/static/qiye/image/home/${item.imgUrl}.png`"
              />
            </div>
            <div class="cDesc">
              <img
                :src="`https://respool.isheji.com/isheji/static/qiye/image/home/${item.logoUrl}.png`"
              />
              <div class="text">
                <section
                  v-html="text"
                  v-for="(text, index) in item.textList"
                  :key="index"
                ></section>
              </div>

              <router-link :to="{ path: '/case' }">
                <div class="button">
                  了解更多
                  <i class="el-icon-right"></i>
                </div>
              </router-link>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="speak">
        <div class="desc" >
          <section
            class="animate__animated animate__fadeInUp"
            v-for="(item, index) in textdata.speak.peopleList[animate.speak.activeIndex].textList"
            :key="index">
            {{ item }}
          </section>
        </div>
        <div class="people">
          <div
            class="item"
            @click="animate.speak.activeIndex = index"
            v-for="(item, index) in textdata.speak.peopleList"
            :key="index"
          >
            <img
              class="light-img"
              v-show="animate.speak.activeIndex == index"
              :src="`https://respool.isheji.com/isheji/static/qiye/image/home/${item.lightUrl}.png`"
            />
            <img
              class="dark-img"
              v-show="animate.speak.activeIndex != index"
              :src="`https://respool.isheji.com/isheji/static/qiye/image/home/${item.darkUrl}.png`"
            />
            <div class="name" v-show="animate.speak.activeIndex == index">
              {{ item.name }}
            </div>
            <div class="title" v-show="animate.speak.activeIndex == index">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="clients">
        <div class="clients_title">合作客户</div>
        <div class="clients_content">
          <div class="clients_wrap">
            <img src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/home/logo.png" alt="" class="kehu_left">
            <img src="https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/home/logo.png" alt="" class="kehu_right">
          </div>
        </div>
      </div>
      <div class="title">爱设计新动态</div>
      <div class="dynamic">
        <div class="item" v-for="item in articleContent" :key="item.title">
          <div class="header">
            <img
              :src="`https://respool.isheji.com/isheji/static/qiye/image/home/${item.icon}`"
            />
            <div class="desc">
              <div class="title">{{ item.title }}</div>
              <div class="tips">{{ item.subtitle }}</div>
            </div>
          </div>
          <div class="footer">
            <div
              class="events"
              v-for="(events, index) in item.list"
              :key="index"
              @click="goArticle(events.url)"
            >
              <div class="text">{{ events.name }}</div>
              <!-- <div class='text'>此处为标题最多十五个字体超出点五个字体超出点</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 邀请加入团队的弹框 -->
    <el-dialog
      class="invite-dialog dialog-364"
      :title="invitorName + '邀请你加入' + invitorTeamName"
      :visible.sync="inviteVisible"
    >
      <div class="btn-wrap">
        <button class="remove-btn refuse" @click="inviteVisible = false">
          拒绝
        </button>
        <button class="confirm-btn join" @click="joinTeam">加入</button>
      </div>
    </el-dialog>
    <!-- 等待审批弹框 -->
    <el-dialog
      class="wait-dialog dialog-364"
      title="加入团队申请已提交，等待审批中"
      :visible.sync="waitVisible"
    >
      <div class="btn-wrap">
        <button class="ok-btn to-template" @click="waitVisible = false">
          好的
        </button>
      </div>
    </el-dialog>
    <!-- 链接失效弹框 -->
    <el-dialog
      class="overdue-dialog dialog-364"
      title="该邀请链接已失效，请提醒对方重新邀请"
      :visible.sync="overdueVisible"
    >
      <div class="btn-wrap">
        <button class="ok-btn" @click="overdueVisible = false">好的</button>
      </div>
    </el-dialog>
    <!-- 重复加入提示弹框 -->
    <el-dialog
      class="repeat-dialog dialog-364"
      :title="'你已加入' + invitorTeamName + '，请勿重复加入'"
      :visible.sync="repeatVisible"
    >
      <div class="btn-wrap">
        <button class="ok-btn to-team" @click="toTeam">前往团队</button>
      </div>
    </el-dialog>
    <!-- 团队过期弹窗 -->
    <el-dialog
      class="to-pay-dialog dialog-364"
      title="该团队已过期，请告知创建人续费后使用"
      :visible.sync="topayvisible"
    >
      <div class="btn-wrap">
        <button class="ok-btn" @click="topayvisible = false">好的</button>
      </div>
    </el-dialog>
    <!-- 团队成员已满弹窗 -->
    <el-dialog
      class="to-pay-dialog dialog-364"
      title="该团队成员已满，请告知创建人续费后使用"
      :visible.sync="topayvisibleMember"
    >
      <div class="btn-wrap">
        <button class="ok-btn" @click="topayvisibleMember = false">好的</button>
      </div>
    </el-dialog>
    <!-- 播放视频弹窗 -->
    <el-dialog
      class="play-video-dialog dialog-364"
      :visible.sync="playVisible"
      @open="openVideo"
      @close="closeVideo"
    >
      <div class="play-video-wrap">
        <video
          src="https://respool.isheji.com/isheji/static/qiye/video/isheji-product-introduction.mp4"
          controls
          ref="video"
        ></video>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import 'animate.css'
import { Member } from '../../../config/axios/new_api'
export default {
  name: 'HomeView',
  data() {
    return {
      // 邀请加入团队的弹框
      inviteVisible: false,
      // 等待审批弹框
      waitVisible: false,
      // 链接失效弹框
      overdueVisible: false,
      // 重复加入提示弹框
      repeatVisible: false,
      // 播放视频弹框
      playVisible: false,
      // 链接是否失效，链接的邀请人和团队名称
      linkInfo: {},
      // 链接邀请人的名字
      invitorName: '',
      // 链接邀请团队的名字
      invitorTeamName: '',
      // 邀请码
      inviteCode: '',
      team_id: '',
      designmessageVisiable: false,
      // 团队过期，需要去续费的弹窗
      topayvisible: false,
      // 团队成员已满的弹窗
      topayvisibleMember: false,
      linkInfo: {},
      carouselImg: [
      {
          img:
            'https://respool.isheji.com/isheji/static/qiye/image/home/carouselImg2.png',
          left: '710px',
          title: '立即体验',
          bgkColor: ['#121217','#121217']
        },
        {
          img: 'https://respool.isheji.com/isheji/static/qiye/image/home/carouselImg6.png',
          style: {
            marginRight: '1023px',
            width: '200px',
            height: '54px',
            opacity: 0,
            borderRadius: '27px',
          },
          top: '495px',
          title: '点击免费下载',
          bgkColor: ['#040507','#0e080d']
        },

        // {
        //   img: 'https://dam-static.isheji.com/qiye1.0/banner2.png',
        //   style: {
        //     marginRight: '1323px',
        //     width: '200px',
        //     height: '54px',
        //     opacity: 0,
        //     borderRadius: '27px',
        //   },
        //   top: '504px',
        //   title: '点击免费下载',
        //   bgkColor: ['#121217','#121217']
        // },
        {
          img:
            'https://respool.isheji.com/isheji/static/qiye/image/home/carouselImg3.png',
          left: '1020px',
          title: '点击下载',
          bgkColor: ['#000','#080808']
         }
      ],
      animate: {
        banner: {
          stepOne: false,
          stepTwo: false,
          stepThree: false,
          stepFour: false
        },
        path: {
          activeItem: 1,
          stillPath: null,
          hoverItem: null,
          markX: [
            {
              marginRight: '1019px'
            },
            {
              marginRight: '505px'
            },
            {
              marginRight: ''
            },
            {
              marginLeft: '505px'
            },
            {
              marginLeft: '1019px'
            }
          ]
        },
        lab: {
          bannerStyle: {
            top: '3256'
          }
        },
        chart: {
          activeIndex: 0
        },
        speak: {
          activeIndex: 0
        }
      },
      textdata: {
        chart: {
          list: [
            {
              logoUrl: 'carousel_logo_1',
              imgUrl: 'carousel_img_1',
              textList: [
                '“爱设计通过为新东方搭建企业内容中',
                '心，解决了新东方的设计支持问题，提',
                '升了品牌管理效率，为营销过程的信息',
                '化管理提供了良好的抓手，爱设计助力',
                '新东方打造了从0到1高质量创意，从',
                '1-100的高效营销协作。”'
              ],
              name: 'xdf',
              id: 3
            },
            {
              logoUrl: 'carousel_logo_2',
              imgUrl: 'carousel_img_2',
              textList: [
                '“基于平安银行信用卡中心在运营私域',
                '矩阵期间大量的内容素材需求，爱设计',
                '从创意采买到智能设计到内容资产管',
                '理，通过ConTech智能内容创意解决方',
                '案为中国平安信用卡实现创意产能的释',
                '放。”'
              ],
              name: 'payh',
              id: 5
            },
            {
              logoUrl: 'carousel_logo_3',
              imgUrl: 'carousel_img_3',
              textList: [
                '“爱设计联合视觉中国通过为元气森林',
                '搭建内容中台，为元气森林输出大量营',
                '销创意，同时帮助元气森林建立新媒体',
                '素材中心和保障内容素材安全存储的数',
                '字资产管理平台，助力元气森林打造了',
                '深刻的品牌记忆。”'
              ],
              name: 'yqsl',
              id: 6
            }
          ]
        },
        speak: {
          peopleList: [
            {
              name: '柴继军',
              title: '视觉中国总裁',
              lightUrl: 'people_head_1',
              darkUrl: 'people_head_1',
              textList: [
                '从目前市场的实践来看，内容中台是企业内容数字',
                '化转型的最佳路径之一，视觉中国积极参与到内容',
                '中台的核心使命-优质内容生产中来，为客户提供优',
                '质海量、版权合规的图片、视频、音乐、字体等素',
                '材内容，全面赋能企业数字化内容营销。'
              ]
            },
            {
              name: '桑文峰',
              title: '神策数据创始人/CEO',
              lightUrl: 'people_head_2',
              darkUrl: 'people_head_2',
              textList: [
                '针对当下“数据+技术”双驱动的发展态势，以及营销',
                '数字化时代的到来，内容中台应运而生。内容中台',
                '能够基于企业痛点，实现从生产、存储、审核、取',
                '用、分发、反馈等内容流转，更高效科学地设计和',
                '组织营销素材，驱动企业核心业务指标增长。'
              ]
            },
            {
              name: '赵充',
              title: '微梦传媒&爱设计创始人/CEO',
              lightUrl: 'people_head_3',
              darkUrl: 'people_head_3',
              textList: [
                '在流量趋势从增量到存量，精细化运营、降本增效成为企',
                '业营销转型的主旋律时，内容中台将是继CDP/MA 之',
                '后，拉动企业品牌增长的第三架马车。'
              ]
            },
            {
              name: '王浩',
              title: '流量池研究所联合创始人/瑞幸咖啡私域顾问',
              lightUrl: 'people_head_4',
              darkUrl: 'people_head_4',
              textList: [
                '移动互联网多元化垂直化的高速发展，线上线下消费链路',
                '的无缝打通已经构建了新的消费生态和消费习惯。在这种',
                '背景下，传统企业如何打破行业周期，爱设计内容中台给',
                '出了一份可落地的答卷，高度成熟化可配置的产品模块和',
                '开放接口，帮助企业以较低门槛布局数字化，以内容中台',
                '驱动组织协同和转化效率提升，实现销量的稳步增长。'
              ]
            },
            {
              name: '徐志斌',
              title: '见实科技创始人',
              lightUrl: 'people_head_5',
              darkUrl: 'people_head_5',
              textList: [
                '纵观许多品牌的私域发展，内容体现无处不在，从欢迎话',
                '术到活动发起，从直播到短视频，从朋友圈到群内沟通，',
                '从一对一细聊到面对海量用户，好内容能让转化效果大',
                '增，而最稀缺的恰恰是无数环节中的优质内容，以及能让',
                '好内容同步到所有员工、每个用户、每个分销员、每个场',
                '景、每个触点中的内容中台。'
              ]
            },
            {
              name: '梅波',
              title: '弯弓Digital创始人',
              lightUrl: 'people_head_6',
              darkUrl: 'people_head_6',
              textList: [
                '在弯弓的五力增长模型中，内容力是企业数字化营销的核心',
                '能力，是实现产品推广、用户连接、渠道赋能和品牌建设的',
                '重要手段。而要保证内容的合规性、系统性、智创性，并实',
                '现千人千面分发管理、有效的标签化洞察，就需要部署内容',
                '中台系统。营销数字化时代，创建强大的内容力是每个伟大',
                '企业的必由之路。感谢爱设计的探索和付出！'
              ]
            },
            {
              name: '霍太稳',
              title: '极客邦科技创始人&CEO/InfoQ中国创始人',
              lightUrl: 'people_head_7',
              darkUrl: 'people_head_7',
              textList: [
                '新经济持续发展，催生了大量新消费需求，同时也拓展了更',
                '多数字化的应用场景，对品牌的数字化营销提出了更高的挑',
                '战，大量的内容需求如何高效满足？内容数字化是必经之',
                '路。爱设计选择的赛道非常精深且艰难，但这正体现了它的',
                '责任感和目标感—通过数字化技术，为品牌内容营销提供科',
                '技赋能，促进内容效率的飞升。'
              ]
            },
            {
              name: '周再宇',
              title: '科特勒增长实验室内容专家',
              lightUrl: 'people_head_8',
              darkUrl: 'people_head_8',
              textList: [
                '在目前的存量竞争时代，内容营销能够帮助企业提高用',
                '户黏性，从而挖掘交易机会。但是，以往的内容创作与',
                '复用严重依赖于人工，具有一定的不确定性和不稳定',
                ' 性。内容中台通过数据收集和分析，辅助传播策划和内',
                '容生产，能够有效助力内容营销降本增效。'
              ]
            }
          ]
        }
      },
      articleContent: [
        {
          icon: 'dynamic_1.png',
          title: '产品动态',
          subtitle: '专注、口碑、极致',
          list: [
            {
              name: '全新品牌矩阵',
              url: 'https://mp.weixin.qq.com/s/3QdCVcqVmNKwqGcatKN6LA'
            },
            {
              name: 'AI H5',
              url: 'https://mp.weixin.qq.com/s/W5F1xT-9JyW8KkQBuSgKZQ'
            },
            {
              name: 'AI PPT',
              url: 'https://mp.weixin.qq.com/s/K2k3oLrCsn-Mr13s2tJoiA'
            }
          ]
        },
        {
          icon: 'dynamic_2.png',
          title: '客户成功',
          subtitle: '一站式营销设计解决方案',
          list: [
            {
              name: '爱设计 X 志邦家居｜内容中台全面赋能',
              url: 'https://mp.weixin.qq.com/s/lzy0yPI4Cx-GAG_KiMWk8w'
            },
            {
              name: '爱设计 X 哪吒汽车｜AIGC宣传片燃爆朋友圈',
              url: 'https://mp.weixin.qq.com/s/oj0EUT5XCC0Yc0zA66Dh_A'
            },
            {
              name: 'iSHEJI X AIGC｜AI系列作品',
              url: 'https://mp.weixin.qq.com/s/Iol3pb5_NGMpuAP-R2BbLQ'
            }
          ]
        },

        {
          icon: 'dynamic_3.png',
          title: '最新活动',
          subtitle: 'iSHEJI市场动态',
          list: [
            {
              name: '爱设计×中国第八届内容营销高峰论坛',
              url: 'https://mp.weixin.qq.com/s/uEenPu798x2dzeRlWc5XLA'
            },
            {
              name: '爱设计×2023见实大会',
              url: 'https://mp.weixin.qq.com/s/cyAddJseJzO5gwHDraGIew'
            },
            {
              name: '长江商学院数字经济学会参访爱设计',
              url: 'https://mp.weixin.qq.com/s/oFwXNhTg8ZBtPf9membJGA'
            }
          ]
        }
      ],
      pathCard2List: [
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_1.png',
            title: '平面编辑器',
            text: '30万+模板，新媒体场景全覆盖'
        },
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_2.png',
            betaImg: 'https://respool.isheji.com/isheji/static/qiye/image/home/beta.png',
            title: '智能文案',
            text: '随身文案助理，激发无穷灵感'
        },
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_3.png',
            title: 'H5网页制作',
            text: '无需代码，轻松制作精美网页'
        },
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_4.png',
            title: '智能延展',
            text: '上传PSD，多尺寸视觉智能生成'
        },
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_5.png',
            title: '视频编辑器',
            text: '视频剪辑，批量生成短视频'
        },
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_6.png',
            title: '智能写作',
            text: '文章校对、续写、重写，一键搞定'
        },
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_7.png',
            title: '智能批量抠图',
            text: '在线玩转抠图，小白也能轻松上手'
        },
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_8.png',
            title: '智能批量套版',
            text: '一次设计批量生产，让创意成倍放大'
        },
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_9.png',
            title: '智能设计',
            text: '一句话、一张图、一键生成'
        },
        {
            img: 'https://respool.isheji.com/isheji/static/qiye/image/home/new_path_card_10.png',
            title: '视频批量剪辑',
            text: '脚本智能编写，视频批量剪辑'
        },
      ],
      cardItem3List: [
        {
          title: '营销素材收集与整理',
          desc: '企业自有素材、内容代理创作素材、UGC创作素材等在线存储，营销内容数字化沉淀管理，提高内容复用率。'
        },
        {
          title: '智能标签+智能搜索',
          desc: '图像+视频+文字内容识别，多维度内容标签，关键词、条件、分类，多维度搜索方式，精细化管理复杂的内容场景。'
        },
        {
          title: '智能合规+权限控制',
          desc: '智能违规内容检测、版权标记、预设品牌规范，让违规内容无所遁形；通过内容、人、组织三个维度的权限控制，实现内容和管理的精细化。'
        },
      ]
    }
  },
  created() {
    //banner加载
    new Promise((resolve) => {
      setTimeout(() => {
        this.animate.banner.stepOne = true
        resolve()
      }, 200)
    })
      .then(() => {
        setTimeout(() => {
          this.animate.banner.stepTwo = true
        }, 400)
      })
      .then(() => {
        setTimeout(() => {
          this.animate.banner.stepThree = true
        }, 600)
      })
      .then(() => {
        setTimeout(() => {
          this.animate.banner.stepFour = true
        }, 800)
      })
    this.stillPath()
    this.getInvite()
  },
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo
    }
  },

  methods: {
    stillPath: function () {
      //轮播path
      this.animate.path.stillPath = setInterval(() => {
        if (this.animate.path.activeItem < 5) {
          this.animate.path.activeItem++
        } else {
          this.animate.path.activeItem = 1
        }
      }, 12000)
    },
    choicePathItem: function (index) {
      this.animate.path.activeItem = null
      this.animate.path.activeItem = index
      if (this.animate.path.stillPath) {
        clearInterval(this.animate.path.stillPath)
        this.animate.path.stillPath = null
        setTimeout(() => {
          this.stillPath()
        }, 12000)
      }
    },
    scrollLab: function (evt, el) {
      if (window.scrollY > 1528 && window.scrollY < 1648) {
        el.setAttribute('style', 'top:' + (3076 - window.scrollY) + 'px')
      }
    },
    goArticle(url) {
      // let routeOne = this.$router.resolve({
      //   path: "/article",
      //   query: {
      //     url: url,
      //   },
      // });
      window.open(url, "_blank");
      // this.$router.push({
      //   path: '/article',
      //   query: {
      //     url: url,
      //     name: name
      //   }
      // })
    },
    // 判断是否有邀请信息
    async getInvite() {
      if (window.location.href.indexOf('invite') !== -1) {
        // 从url中获取邀请码
        this.inviteCode = window.location.search.split('=')[1]
        // 根据邀请码判断链接是否已失效，并获取此链接的邀请信息
        this.linkInfo = await this.linkIsDisabled(this.inviteCode)

        // 链接邀请人的名字
        var invitorNameStr =
          this.linkInfo.user_name == undefined ? '' : this.linkInfo.user_name
        this.invitorName =
          invitorNameStr.length <= 6
            ? invitorNameStr
            : invitorNameStr.substring(0, 5).concat('...')
        // 链接邀请团队的名字
        var teamNameStr =
          this.linkInfo.team_name == undefined ? '' : this.linkInfo.team_name
        this.invitorTeamName =
          teamNameStr.length <= 6
            ? teamNameStr
            : teamNameStr.substring(0, 5).concat('...')

        this.team_id = this.linkInfo.team_id
        if (!this.linkInfo.is_expired) {
          // 没有失效，显示加入弹窗
          var isJoined = await this.isJoined()
          if (isJoined == 1) {
            window.location.href = process.env.VUE_APP_BASELogout
          } else {
            this.inviteVisible = true
          }
        } else {
          // 失效，提示失效弹窗
          this.overdueVisible = true
        }
      }
    },
    async linkIsDisabled(code) {
      return await Member.invitor({ code: code }).then((response) => {
        if (response.status == 1) {
          return response.data
        } else {
          return { 'is_expired': true }
        }
      })
    },
    // 点击加入团队的按钮-----------------------------------------
    async joinTeam() {
      if (this.loginInfo) {
        // 已登录，判断是否已加入 0未加入，1已加入
        var isJoined = await this.isJoined()
        if (isJoined === 0) {
          //  未加入	调用申请加入团队的接口
          Member.joinTeam({ code: this.inviteCode }).then((response) => {
            if (response.status == 1) {
              if (response.status_code == 1) {
                window.location.href = process.env.VUE_APP_BASELogout
                return
              }
              this.inviteVisible = false
              if (response.data && response.data.join_team == 1) {
                this.$store.dispatch('loginInfo').then((res) => {
                  let domain = `${res.current_team_domain}`
                  if (process.env.VUE_APP_RealmName) {
                    // 配置域名
                    domain =
                      'https://' +
                      domain.split('.')[0] +
                      `.${process.env.VUE_APP_RealmName}`
                  }
                  if (res.is_open === 2) {
                    if (process.env.NODE_ENV === 'production') {
                      //window.location.href = `https://${domain}`;
                      if (window.location.host.indexOf('isheji.com') !== -1) {
                        this.staticFunc.toHref(`https://${domain}`)
                      } else {
                        this.staticFunc.toHref(domain)
                      }
                    } else {
                      this.staticFunc.toHref('/home')
                    }
                  } else {
                    if (process.env.NODE_ENV === 'production') {
                      if (window.location.host.indexOf('isheji.com') !== -1) {
                        this.staticFunc.toHref(`https://${domain}/template`)
                      } else {
                        this.staticFunc.toHref(`${domain}/template`)
                      }
                      // window.location.href = `https://${domain}/template`;
                    } else {
                      this.staticFunc.toHref('/template')
                    }
                  }
                })
              } else {
                this.waitVisible = true
              }
            } else {
              this.inviteVisible = false
              //  重复提加入团队的申请
              if (response.status_code == 41009) {
                this.waitVisible = true
              } else if (response.status_code == 41023) {
                // 过期
                this.topayvisible = true
              } else if (response.status_code == 41019) {
                // 名额不够了
                this.topayvisibleMember = true
              }
            }
          })
        } else {
          //  已加入，提示已加入
          this.inviteVisible = false
          this.repeatVisible = true
        }
      } else {
        // 未登录，弹出登录弹框
        this.inviteVisible = false
        window.localStorage.setItem('inviteLogin', 'true')
        window.open('/login' + window.location.search)
      }
    },
    // 判断是否已加入：当前用户是否已经通过邀请链接加入了该团队
    async isJoined() {
      return await Member.isjoined({ code: this.inviteCode }).then(
        (response) => {
          if (response.status == 1) {
            return response.data.is_joined
          } else {
            return 0
          }
        }
      )
    },
    toTeam(team) {
      changeTeam({
        team_id: team_id
      }).then((res) => {
        if (res.status === 1) {
          let domain = `${team.domain}`
          if (process.env.VUE_APP_RealmName) {
            // 配置域名
            domain =
              'https://' +
              domain.split('//')[1].split('.')[0] +
              `.${process.env.VUE_APP_RealmName}`
          }
          if (team.is_open === 2) {
            if (process.env.NODE_ENV === 'production') {
              this.staticFunc.toHref(domain)
            } else {
              this.staticFunc.toHref('/home')
            }
          } else {
            if (process.env.NODE_ENV === 'production') {
              this.staticFunc.toHref(`${domain}/template`)
            } else {
              this.staticFunc.toHref('/template')
            }
          }
        }
      })
    },
    playVideo() {
      this.playVisible = true
    },
    openVideo() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.video.play()
        }, 500)
      })
    },
    closeVideo() {
      this.$refs.video.pause()
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  min-height: 1000px;
}
/* 针对两张图片 */
.custom-carousel {
  ::v-deep( .el-carousel__indicators.el-carousel__indicators--horizontal) {
    width: 76px;
    height: 29px;
  }

  ::v-deep( .el-carousel__indicator.el-carousel__indicator--horizontal){
    position: absolute;

    &:nth-child(2n-1) {
      left: 0;
    }

    &:nth-child(2n) {
      right: 0;
    }
  }
}
.banner {
  // background-image: url('https://respool.isheji.com/isheji/static/qiye/image/home/banner.png');
  width: 100%;
  min-width: 1400px;
  height: 620px;
  background-position-x: center;
  background-size: 1920px 620px;
  position: relative;

  .item {
    width: 100%;
    height: 100%;
    background-size: 1920px;
    background-position: center;
    background-repeat: no-repeat;
    .link {
      position: absolute;
      width: 100%;
      top: 432px;
      display: flex;
      justify-content: center;
    }
    .button {
      width: 126px;
      height: 44px;
      background: #5a2df5;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .el-icon-right {
        display: none;
      }

      &:hover {
        .el-icon-right {
          display: block;
          margin-left: 8px;
          color: #ffffff;
        }
      }
    }
    .play {
      background-color: transparent;
      border: 1px solid #ffffff;
      margin-left: 16px;
    }
  }
  .row-interval {
    margin-top: 72px;
  }

  .circle-step-one {
    z-index: 10;
    background-image: url('https://respool.isheji.com/isheji/static/qiye/image/home/banner_circle_1.png');
    width: 100%;
    min-width: 1400px;
    height: 620px;
    background-position-x: center;
    background-size: 1920px 620px;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 700px;

    .title {
      font-size: 48px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 67px;
      margin-top: 156px;
    }

    .tips {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 40px;
      margin-top: 16px;
    }

    .desc {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #929296;
      line-height: 22px;
      text-align: center;
      margin-top: 40px;
    }

    .button {
      width: 126px;
      height: 44px;
      background: #5a2df5;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-top: 40px;

      .el-icon-right {
        display: none;
      }

      &:hover {
        .el-icon-right {
          display: block;
          margin-left: 8px;
          color: #ffffff;
        }
      }
    }
  }

  .circle-step-two {
    background-image: url('https://respool.isheji.com/isheji/static/qiye/image/home/banner_circle_2.png');
    width: 100%;
    min-width: 1400px;
    height: 620px;
    background-size: 1920px 620px;
    background-position-x: center;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 135px;

    .context {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 390px;
      width: 234px;
      margin-left: 60px;

      .desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #38bebe;
        line-height: 20px;
        height: 100%;

        .row-two {
          margin-left: 20px;
        }

        .row-three {
          margin-left: 40px;
        }

        .row-four {
          margin-left: 20px;
        }
      }

      .title {
        width: 78px;
        height: 30px;
        background: #5a2df5;
        border-radius: 15px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .circle-step-three {
    background-image: url('https://respool.isheji.com/isheji/static/qiye/image/home/banner_circle_3.png');
    width: 100%;
    min-width: 1400px;
    height: 620px;
    background-size: 1920px 620px;
    background-position-x: center;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 640px;

    .context {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 390px;
      width: 234px;

      .desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ac81ff;
        line-height: 20px;
        height: 100%;

        .row-two {
          margin-left: 20px;
        }

        .row-three {
          margin-left: 40px;
        }

        .row-four {
          margin-left: 20px;
        }
      }

      .title {
        width: 78px;
        height: 30px;
        background: #5a2df5;
        border-radius: 15px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .circle-step-four {
    background-image: url('https://respool.isheji.com/isheji/static/qiye/image/home/banner_circle_4.png');
    width: 100%;
    min-width: 1400px;
    height: 620px;
    background-size: 1920px 620px;
    background-position-x: center;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-left: 1105px;

    .context {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 390px;
      width: 234px;

      .desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3d8eff;
        line-height: 20px;
        height: 100%;

        .row-two {
          margin-left: 20px;
        }

        .row-three {
          margin-left: 40px;
        }

        .row-four {
          margin-left: 20px;
        }
      }

      .title {
        width: 78px;
        height: 30px;
        background: #5a2df5;
        border-radius: 15px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.path {
  position: relative;
  z-index: 1;

  .header {
    height: 384px;
    background: #24242c;
    min-width: 1400px;

    .title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 45px;
      text-align: center;
      padding-top: 70px;
    }

    .context {
      width: 1200px;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 48px;

      div {
        margin-right: 46px;

        &:last-child {
          margin-right: 0;
        }
      }

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        width: 130px;
        height: 130px;

        &:hover {
          border-radius: 4px;
          background-color: #30303a;
        }

        .img {
          width: 40px;
        }

        .text {
          margin-top: 19px;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 25px;
        }
      }

      .arrow img {
        width: 32px;
      }
    }
  }

  .card {
    height: 613px;
    background-color: #24242c;
    min-width: 1400px;

    .mark {
      display: flex;
      justify-content: center;
      margin-top: -25px;

      .sub {
        background-image: url('~@/assets/image/mark.svg');
        height: 25px;
        width: 38px;
        display: block;
        transition: 0.3s;
      }
    }

    .card-item1 {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .iTitle {
        .bold {
          font-size: 24px !important;
          color: #3B3946 !important;
          line-height: 33px !important;
        }
        .thin {
          font-size: 16px !important;
          color: #3B3946 !important;
          line-height: 22px !important;
        }
      }
      .content {
        margin-top: 40px !important;
        justify-content: space-between !important;
        img {
          width: 595px;
          height: 347px;
        }
      }
      .item {
        width: 500px !important;
        border: none !important;
        cursor: auto !important;
        background-color: transparent !important;
        &:hover{
          box-shadow: none !important;
        }
      }
    }

    .card-item2 {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      // height: 718px;
      .card-show {
          height: 100%;
      }
      .content {
        width: 1200px;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start !important;
        margin: auto;
        margin-top: 47px !important;
      }
      .item {
        width: 282px !important;
        height: 86px !important;
        padding: 16px !important;
        margin-bottom: 24px;
        box-sizing: border-box !important;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #e8e6ee !important;
        margin-right: 24px;
        display: flex;
        align-items: flex-start !important;
        flex-direction: row !important;
        &:nth-child(4n) {
          margin-right: 0;
        }
        img {
          width: 54px;
          margin-right: 14px;
        }
        padding: 16px;
        .iContent {
          margin-top: 0 !important;
          position: relative;
          .title {
            padding: 0;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3b3946;
            line-height: 28px;
          }
          .beta-img{
            width: 33px;
            height: 16px;
            position: absolute;
            top: -2px;
            left: 86px;
          }
          .desc {
            margin-top: 9px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6e6c76;
            line-height: 12px;
            section {
              white-space: nowrap;
            }
          }
        }
      }
      .more {
        margin-bottom: 21px;
        width: 98px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 4px;
        border: transparent;
        color: #3B3946;
      }
    }


    .card-item4 {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .introduce {
        img {
          margin-left: 88px;
          width: 476px;
          height: 310px;
        }
      }
    }

    .card-item5 {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .introduce {
        img {
          margin-right: 70px;
          width: 470px;
          height: 305px;
        }
      }
    }

    .card-show {
      width: 100%;
      background-color: #f7f7fb;
      height: 585px;
      text-align: center;

      .title {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #3b3946;
        line-height: 45px;
        padding-top: 64px;
      }

      .desc {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6e6c76;
        line-height: 22px;
        margin-top: 24px;
      }

      .content {
        margin-top: 64px;
        display: flex;
        justify-content: center;
        align-items: center;

        .router-item {
          margin-right: 24px;

          &:last-child {
            margin-right: 0;
          }
        }

        .item {
          width: 384px;
          height: 228px;
          padding: 24px 20px;
          box-sizing: border-box;
          background-color: #ffffff;
          border-radius: 8px;
          border: 1px solid #e8e6ee;
          text-align: left;
          cursor: pointer;
          display: flex;
          flex-direction: column;

          &:hover {
            box-shadow: 0px 12px 28px 0px rgba(63, 63, 70, 0.14);

            .iFooter {
              color: #5a2df5;
            }
          }

          .iheader {
            display: flex;
            align-items: center;

            img {
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }

            .iTitle {
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              .bold {
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3b3946;
                line-height: 28px;
              }

              .thin {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9e9da7;
                line-height: 20px;
              }
            }
          }

          .iContent {
            margin-top: 20px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6e6c76;
            line-height: 20px;
            flex: 1;
          }

          .iFooter {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3b3946;
            line-height: 20px;

            .text {
              margin-right: 12px;
            }
          }
        }
      }

      .introduce {
        display: flex;
        justify-content: center;
        margin-top: 44px;

        .context {
          text-align: left;

          .cTitle {
            display: flex;
            align-items: center;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3b3946;
            line-height: 28px;
            margin-bottom: 8px;

            &::before {
              content: '';
              width: 12px;
              height: 6px;
              background: #5a2df5;
              border-radius: 1px;
              margin-right: 8px;
            }
          }

          .cDesc {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6e6c76;
            line-height: 20px;
            margin-bottom: 24px;
          }
        }
      }


      .cButton {
        width: 126px;
        height: 44px;
        background: #5a2df5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 20px;
        cursor: pointer;
        margin-top: 32px;

        .el-icon-right {
          display: none;
        }

        &:hover {
          .el-icon-right {
            display: block;
            margin-left: 8px;
            color: #ffffff;
          }
        }
      }
    }
    .card-item3 {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .content {
        margin-top: 35px;
        display: flex;
        .content_left {
          width: 467px;
          .left_item {
            margin-bottom: 24px;
            &:last-child {
              margin-bottom: 32px;
            }
            .left_title {
              font-size: 20px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #3B3946;
              line-height: 28px;
              margin-bottom: 8px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .icon {
                width: 12px;
                height: 6px;
                background-color: #5A2DF5;
                margin-right: 8px;
              }
            }
            .left_desc {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #6E6C76;
              line-height: 20px;
              text-align: left;
            }
          }
        }
        .content_right {
          flex: 1;
          flex-shrink: 0;
          img {
            width: 595px;
            height: 347px;
          }
        }
      }
    }
  }
}

.lab {
  width: 100%;
  min-width: 1400px;
  height: 594px;
  z-index: 2;
  background: #030000;

  .content {
    z-index: 14;
    position: relative;
    width: 1200px;
    margin: auto;

    .title {
      padding-top: 145px;

      img {
        width: 241px;
        height: 67px;
      }
    }

    .tips {
      margin-top: 24px;
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 28px;
    }

    .desc {
      margin-top: 48px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #929296;
      line-height: 22px;
    }

    .button {
      margin-top: 48px;
      width: 126px;
      height: 44px;
      background: #5a2df5;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
      cursor: pointer;

      .el-icon-right {
        display: none;
      }

      &:hover {
        .el-icon-right {
          display: block;
          margin-left: 8px;
          color: #ffffff;
        }
      }
    }
  }
}

.lab_banner {
  position: absolute;
  top: 1568px;
  background-image: url('https://respool.isheji.com/isheji/static/qiye/image/home/lab_banner.png');
  background-repeat: no-repeat;
  background-size: 1208px 714px;
  background-position-y: 0;
  min-width: 1400px;
  background-position-x: 100%;
  width: 100%;
  height: 714px;
}

.chart {
  height: max-content;
  width: 100%;
  min-width: 1400px;
  position: relative;
  padding-top: 80px;
  text-align: center;
  background-color: #030000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 80px;
  .title {
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 45px;
  }

  .center-flex-box {
    margin-top: 56px;
    display: flex;
    justify-content: center;
    margin-bottom: 128px;

    .item {
      margin-right: 24px;
      width: 384px;
      height: 332px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      flex-direction: column;

      &:last-child {
        margin-right: 0;
      }

      img {
        margin: 10px 10px 0 10px;
      }

      .text {
        padding-left: 20px;
        text-align: left;
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #3b3946;
        line-height: 22px;
      }
    }
  }

  .el-carousel__indicators--outside {
    margin-top: 32px;
  }

  .el-carousel__button {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }

  .el-carousel {
    margin-top: 14px;
    width: 1352px;
    box-sizing: border-box;

    .el-carousel__container {
      overflow: hidden;

      .el-carousel__item {
        display: flex;
        justify-content: center;

        // perspective: 200px;
        .el-carousel__item--card {
          background: #fff;
        }

        .el-carousel__mask {
          transform: translateZ(-200px);
        }

        .item {
          width: 1080px;
          height: 530px;
          display: flex;
          max-width: 100%;
          transform: scale(0.8);

          .cImg {
            width: 720px;
            height: 530px;
            background: #3d3d4a;
            border-radius: 12px 0px 0px 12px;
            display: flex;
            align-items: flex-start;
            padding-top: 70px;
            padding-left: 36px;
            padding-bottom: 7px;

            img {
              width: 676px;
              height: 422px;
            }
          }

          .cDesc {
            width: 360px;
            height: 530px;
            background: #ffffff;
            border-radius: 0px 12px 12px 0px;
            padding-left: 40px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding-top: 75px;
            text-align: left;

            img {
              height: 54px;
              margin-bottom: 24px;
            }

            .text {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #6e6c76;
              line-height: 28px;
              margin-bottom: 46px;
            }

            .button {
              width: 126px;
              height: 44px;
              background: #5a2df5;
              border-radius: 4px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              cursor: pointer;
              line-height: 20px;

              .el-icon-right {
                display: none;
              }

              &:hover {
                .el-icon-right {
                  display: block;
                  margin-left: 8px;
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
    }
  }

  // .el-carousel__mask{
  //     transform: scale(0.83);
  // }
  // .el-carousel__item--card.is-active{
  //   width: 1080px;
  //   height: 480px;
  //   transform: translateX(123px) scale(1) !important;
  //   .item{
  //      transform: scale(1) !important;
  //   }
  // }
  .speak {
    margin-top: 80px;
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 96px;

    .desc {
      margin-bottom: 47px;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/home/speak.png');
      background-size: 100%;
      width: 640px;
      height: 160px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
    }

    .people {
      display: flex;

      .item {
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 12px;
        max-width: 64px;

        &:last-child {
          margin-right: 0;
        }

        .light-img {
          width: 64px;
          height: 64px;
        }

        .dark-img {
          margin-top: 12px;
          width: 40px;
          height: 40px;
          opacity: 0.5;

          &:hover {
            opacity: 1;
          }
        }

        .name {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 22px;
          margin-top: 8px;
        }

        .title {
          margin-top: 8px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #6e6c76;
          line-height: 17px;
          white-space: nowrap;
        }
      }
    }
  }

  .animate__animated.animate__fadeInUp {
    --animate-duration: 0.2s;
  }
  .clients {
    width: 1240px;
    margin-bottom: 40px;
    .clients_title {
      min-width: 1240px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 45px;
      margin-bottom: 12px;
      text-align: center;
    }
    .clients_content {
      margin: 0 auto;
      .clients_wrap {
        height: 284px;
        position: relative;
        overflow: hidden;
        &::before {
          content: '';
          display: block;
          position: absolute;
          left: 0;
          top: 0;
          bottom: 0;
          right: 0;
          z-index: 9;
          background-image: url('https://dam-static.oss-cn-beijing.aliyuncs.com/qiye1.0/home/logo_mark.png');
          background-size: 1240px 384px;
          background-repeat: no-repeat;
        }
        img {
          height: 284px;
          object-fit: contain;
          position: absolute;
          top: 50%;
          left: 0;
        }
        .kehu_left {
          transform: translate(0, -50%);
          animation: swiper-left 60s linear infinite;
        }
        .kehu_right {
          transform: translate(calc(100% - 1px), -50%);
          animation: swiper-right 60s linear infinite;
        }
        @keyframes swiper-left {
          0% {
            transform: translate(0, -50%);
          }
          to {
            transform: translate(-100%, -50%);
          }
        }
        @keyframes swiper-right {
          0% {
            transform: translate(calc(100% - 1px), -50%);
          }
          to {
            transform: translate(-1px, -50%);
          }
        }
      }
    }
  }
  .dynamic {
    margin-top: 56px;
    display: flex;
    justify-content: center;
    text-align: left;

    .item {
      padding: 30px 36px;
      margin-right: 24px;
      width: 384px;
      height: 254px;
      background: #ffffff;
      box-shadow: 0px 14px 27px 0px rgba(48, 48, 54, 0.06);
      border-radius: 8px;

      &:last-child {
        margin-right: 0;
      }

      .header {
        display: flex;
        align-items: center;
        border-bottom: 1px dashed #E4E2EB;
        padding-bottom: 28px;

        img {
          width: 68px;
          height: 68px;
          margin-right: 12px;
        }

        .desc {
          .title {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #2d2d32;
            line-height: 28px;
            margin-bottom: 4px;
          }

          .tips {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6e6c76;
            line-height: 20px;
          }
        }
      }

      .footer {
        margin-top: 19px;
        .events {
          margin-bottom: 10px;
          display: flex;
          cursor: pointer;

          &:last-child {
            margin-bottom: 0;
          }

          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2d2d32;
          line-height: 22px;

          .date {
            margin-right: 8px;
          }

          .text {
            width: 258px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

.dialog-364 {
  ::v-deep( .el-dialog) {
    width: 364px;
    height: 244px;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
    top: 50%;
    transform: translateY(-50%);
    margin-top: 0 !important;
  }

  ::v-deep( .el-dialog__header) {
    padding: 40px 0 0 0;
    width: 100%;
    height: 156px;
    box-sizing: border-box;
    text-align: center;

    ::v-deep( .el-dialog__title) {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(60, 60, 67, 1);
      line-height: 20px;
    }

    ::v-deep( .el-icon-close ){
      font-size: 20px;
      color: #3d3d44;
    }
  }

  ::v-deep( .el-dialog__body) {
    width: 100%;
    padding: 0;
  }

  ::v-deep( .el-dialog__header) {
    padding: 88px 0 0 0;
  }

  ::v-deep( .el-dialog__title) {
    color: rgba(45, 45, 50, 1);
  }

  .btn-wrap {
    width: 100%;
    display: flex;
    padding: 0 48px;
    box-sizing: border-box;
    justify-content: space-between;

    .cancel-btn {
      @include primary-button($background: rgba(255, 255, 255, 1));
      border: 1px solid rgba(100, 100, 105, 1);
      box-sizing: border-box;
      color: rgba(60, 60, 67, 1);
    }

    .confirm-btn {
      @include primary-button;
    }

    .ok-btn {
      @include primary-button;
      margin: 0 auto;
    }

    .remove-btn {
      @include primary-button($background: #ff6464);
    }
  }
}
.play-video-dialog {
  ::v-deep( .el-dialog) {
    width: 1156px;
    height: 700px;
    .el-dialog__header {
      height: 50px;
      padding: 0;
    }
    .el-dialog__body {
      height: 650px;
      background-color: #000;
      .play-video-wrap {
        width: 100%;
        height: 100%;
        video {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.banner {
  .el-carousel__arrow {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
}
.chart {
  .el-carousel__arrow {
    width: 60px;
    height: 60px;
    background-color: #ffffff !important;
    color: #3b3946;
    font-size: 24px;
  }

  .el-carousel__arrow--right {
    right: 90px;
  }

  .el-carousel__arrow--left {
    left: 90px;
  }
}

[class*=' el-icon-']:hover,
[class^='el-icon-']:hover {
  color: rgba(138, 136, 143, 0.99);
}
</style>
